import { restCmsRepository, CareerType } from "@onair/repositories";
import { unstable_noStore } from "next/cache";

export const getCompetencyFrameworks = async () => {
	unstable_noStore();
	const response =
		await restCmsRepository.competencyFrameworks.getCompetencyFrameworks({
			// populate: "*",
			"fields[0]": "title",
			"fields[1]": "slug",
			"fields[2]": "description",
			"[populate][thumbnail][fields][0]": "*",
		} as Record<string, string>);
	return response.data;
};

export const getCompetencyFrameworkDetail = async (slug: string) => {
	unstable_noStore();
	const response =
		await restCmsRepository.competencyFrameworks.getCompetencyFrameworks({
			"filters[slug]": slug,
			"populate[divisions][fields][0]": "title",
			"populate[divisions][fields][1]": "imageMap",
			"populate[divisions][populate][competency_job_titles][fields][0]":
				"title",
			"populate[divisions][populate][competency_job_titles][fields][1]": "slug",
			"populate[divisions][populate][competency_division][populate]": "*",
			// "populate[divisions][populate][competency_division][fields][1]": "slug",
		} as Record<string, string | number>);
	return response.data.data?.[0];
};

export const getCompetencyJobDetailBySlug = async (slug: string) => {
	unstable_noStore();
	const response = await restCmsRepository.jobTitles.getJobTitles({
		"filters[slug]": slug,
		// "populate[technicalSkills][populate]": "*",
		// "populate[criticalSkills][populate]": "*",
		// "populate[competency_division][populate]": "*",
		"populate[competency_division][populate][fields][0]": "title",
		"populate[criticalSkills][populate][fields][0]": "title",
		"populate[criticalSkills][populate][fields][1]": "isHighlighted",
		"populate[criticalSkills][populate][competency_level_skill][fields][0]":
			"title",
		"populate[criticalSkills][populate][competency_level_skill][fields][1]":
			"order",
		"populate[criticalSkills][populate][competency_core_skill][fields][0]":
			"title",
		"populate[criticalSkills][populate][competency_core_skill][fields][1]":
			"courseUrl",
		"populate[technicalSkills][populate][fields][0]": "title",
		"populate[technicalSkills][populate][fields][1]": "isHighlighted",
		"populate[technicalSkills][populate][competency_level_skill][fields][0]":
			"title",
		"populate[technicalSkills][populate][competency_level_skill][fields][1]":
			"order",
		"populate[technicalSkills][populate][competency_technical_skill][fields][0]":
			"title",
	} as Record<string, string>);

	return response.data.data?.[0];
};

export const getCompetencyTechnicalSkillDetail = async (id?: number) => {
	unstable_noStore();
	const response =
		await restCmsRepository.competencyTechnicalSkills.getCompetencyTechnicalSkills(
			{
				"filters[id]": id,
				"populate[tsc][populate]": "*",
				"populate[ability][populate]": "*",
				"populate[knowledge][populate]": "*",
				"populate[rangeOfApplication][populate]": "*",
			} as Record<string, string | number>,
		);
	return response.data?.data?.[0];
};

export const getCompetencyCoreSkillDetail = async (id?: number) => {
	unstable_noStore();
	const response =
		await restCmsRepository.competencyCoreSkills.getCompetencyCoreSkills({
			"filters[id]": id,
			"populate[ccs][populate]": "*",
			"populate[ability][populate]": "*",
			"populate[knowledge][populate]": "*",
		} as Record<string, string | number>);
	return response.data?.data?.[0];
};
export const getCompetencyLevels = async () => {
	unstable_noStore();
	const response =
		await restCmsRepository.competencyLevelSkills.getCompetencyLevelSkills({
			populate: "*",
		} as Record<string, string | number>);
	return response.data;
};
